/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/

import { events } from './events/index'

const GeneralSection = {
  events,
};

export { GeneralSection }